import React, {useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {applyHotspotChanges, setSelectedHotspotId, updateHotspot} from "../../actions";
import axios from "axios";
import classNames from "classnames";
import AjaxButton from "src/shared/form/ajax_button";
import _ from "lodash";
import TextEditor from "./text_editor";


export default function PdfViewer(props) {
  const {id,} = props.hotspot
  const pdfFiles = useSelector(state => state.imageHotspotPdfFiles.filter(pf => pf.image_hotspot_id == id))
  const sortedPdfFiles = _.sortBy(pdfFiles, ["position", "filename", "id"], ["asc", "asc", "asc",])
  const dispatch = useDispatch()
  const pdfUrl = useSelector((state) => state.pdfUrl)
  const reorderPdfUrl = useSelector((state) => state.reorderPdfUrl)
  const hotspotUpdateData = useSelector((state) => state.hotspotUpdateData)
  const hasUnsavedChanges = !_.isEmpty(hotspotUpdateData)
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedMediaFile, setSelectedMediaFile] = useState(null);
  const [textEditor, setTextEditor] = useState(null);


  const clearFormData = () => {
    setTitle("")
    setDescription("")
    setSelectedFile(null)
    setSelectedMediaFile(null)
  }

  const selectMediaFile = (mediaFile) => {
    setSelectedMediaFile(mediaFile)
    setTitle(mediaFile.title)
    setDescription(mediaFile.description)
    setSelectedFile(null)

    if (textEditor) {
      textEditor.setContent(mediaFile.description)
    }
  }

  if (hasUnsavedChanges) {
    return <>
      <h5 className="hotspot-setting-header">Unsaved changes</h5>
      <div className="hotspot-setting-info">
        You first need to save your changes before you can continue adding downloads.
      </div>
    </>
  }

  const canUploadFile = !sortedPdfFiles || sortedPdfFiles.length < 10

  let mediaFileContent = null
  console.log({sortedPdfFiles})
  if (sortedPdfFiles && sortedPdfFiles.length > 0) {
    mediaFileContent = <>
      {sortedPdfFiles.map((mediaFile, index) => {
        return <div className="row" key={mediaFile.id}>
          <div className="col-12">
            <hr/>
          </div>
          <div className="col-12 col-md-8">
            <div className="row">
              <div className="col-12">
                <h5 className="hotspot-setting-header">{mediaFile.title}</h5>
                {mediaFile.description ? <div className="hotspot-setting-info" dangerouslySetInnerHTML={{__html: mediaFile.description}}/> : null}
                <a href={mediaFile.url} download>Download File</a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 d-flex justify-content-end">
            {index > 0 ? <AjaxButton
              method="put"
              className={"btn media-file-btn"}
              icon={"fa-arrow-up"}
              url={reorderPdfUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                media_file_id: mediaFile.id,
                direction: "UP"
              }}/> : null}
            {index + 1 < sortedPdfFiles.length ? <AjaxButton
              method="put"
              className={"btn media-file-btn"}
              icon={"fa-arrow-down"}
              url={reorderPdfUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                media_file_id: mediaFile.id,
                direction: "DOWN"
              }}/> : null}
            <AjaxButton
              method="delete"
              className={"btn media-file-btn"}
              icon={"fa-trash"}
              url={pdfUrl}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  clearFormData()
                  dispatch(updateHotspot(data.data.image_hotspot))
                  dispatch(applyHotspotChanges())
                } else {
                  alert(data.data.message || "A error occurred while deleting.")
                }
              }}
              data={{
                hotspot_id: id,
                media_file_id: mediaFile.id
              }}/>
          </div>
          <div className="col-12">
            <button
              className={classNames("btn btn-sm btn-outline-success btn-ueg float-right")}
              type="button"
              onClick={() => selectMediaFile(mediaFile)}
            >
              Edit
            </button>
          </div>
        </div>
      })}
    </>
  }

  return <div>
    {canUploadFile ? <>
      <hr/>
      <div className="row">
        <div className={"col-12" + selectedMediaFile ? " col-md-8" : ""}>
          <h5 className="hotspot-setting-header">
            {selectedMediaFile ? "Edit download item" : "Add a download item"}
          </h5>
          <div className="hotspot-setting-info">
            {selectedMediaFile ? "You currently have a download item selected, which you are editing." : "Just add a download item below."}
          </div>
        </div>
        {selectedMediaFile ? <div className={"col-12 col-md-4 d-flex justify-content-end"}>
          <button
            className={classNames("btn media-file-btn")}
            type="button"
            onClick={() => clearFormData()}
          >
            {"Exit edit mode "}
            <i className="fa fa-times"/>
          </button>
        </div> : null}
      </div>
      <form>
        <div className="form-group">
          <label htmlFor="download_item_description">Description</label>
          <TextEditor
            setEditor={setTextEditor}
            initialEditorState={{html: description}}
            onDataChanged={(data) => {
              setDescription(data.html)
            }}/>
        </div>
        <div className="custom-file">
          <input type="file"
                 className="custom-file-input"
                 id="download_item_file"
                 required
                 onChange={e => setSelectedFile(e.target.files[0])}
          />
          <label className="custom-file-label" htmlFor="download_item_file">{selectedFile?.name || "Choose file..."}</label>
        </div>

        <AjaxButton
          method={selectedMediaFile ? "put" : "post"}
          labelSending="Saving..."
          className={classNames("btn btn-outline-success btn-ueg mt-3")}
          icon="fa-save"
          url={pdfUrl}
          data={() => {
            const data = new FormData()

            data.append("hotspot_id", id)
            data.append("pdf_file", selectedFile)
            data.append("title", title)
            data.append("description", description)

            if (selectedMediaFile) {
              data.append("media_file_id", selectedMediaFile.id)
            }

            return data
          }}
          label={"Save file"}
          onSuccess={(data) => {
            console.error(data)

            if (data.data.status === "OK") {
              clearFormData()
              dispatch(updateHotspot(data.data.image_hotspot))
              dispatch(applyHotspotChanges())
            } else {
              alert(data.data.message || "A error occurred while updating.")
            }
          }}
          onError={(error) => {
            console.error(error)
            alert(error)
          }}
        />
      </form>
    </> : <div>There are no files uploaded yet.</div>}
    {!selectedMediaFile && mediaFileContent ? <>
      <hr/>
      <h5 className="hotspot-setting-header">Downloads</h5>
      <div className="hotspot-setting-info">
        Below you find your added download files.
      </div>
    </> : null}
    {selectedMediaFile ? null : mediaFileContent}
  </div>;
}
